var UpSelling = (function () {
    var upSellingTypes = ["expensive", "sealed"];

    function hideUpSelling() {
        for (var index = 0; index < upSellingTypes.length; index++) {
            var upSellingContainer = $('.' + upSellingTypes[index] + '-up-selling-container');
            if (upSellingContainer.length) {
                upSellingContainer.hide();
            }
        }
    }

    function showUpSelling(upSellingType) {
        if (typeof upSellingType !== 'string') {
            console.error("String value is required");
            return;
        }

        if (!upSellingTypes.includes(upSellingType)) {
            console.error("Unknown up selling type");
            return;
        }

        var upSellingContainer = $('.' + upSellingType + '-up-selling-container');
        if (upSellingContainer.length) {
            upSellingContainer.show();
        }
    }

    function initCarousels() {
        var upsellingCarouselsData = [];
        for (var index = 0; index < upSellingTypes.length; index++) {
            var upSellingCarousel = $('.' + upSellingTypes[index] + '-up-selling-container').find('.cross-elements-div-list');
            if (upSellingCarousel.length) {
                upsellingCarouselsData.push(initCarousel(upSellingCarousel));
            }
        }
        return upsellingCarouselsData;
    }


    function initCarousel(upsellingCarousel) {
        var carouselConfig = getCarouselConfig(upsellingCarousel.parent());
        return {
            carousel: createUpsellingCarousel(upsellingCarousel, carouselConfig),
            maxSlides: carouselConfig.maxSlides
        }
    }

    function getCarouselConfig(upsellingContainer) {
        var containerWidth = upsellingContainer.width();
        var numberOfSlidesDisplayed;
        var mode = 'horizontal';

        if(containerWidth > 740) {
            numberOfSlidesDisplayed = 3;
        } else if (containerWidth < 450) {
            numberOfSlidesDisplayed = 1;
            mode = 'vertical';
        } else {
            numberOfSlidesDisplayed = 2;
        }

        return {
            maxSlides: numberOfSlidesDisplayed,
            minSlides: numberOfSlidesDisplayed,
            pager: false,
            mode: mode,
            prevText:'<i class="fa fa-chevron-left"></i>',
            nextText:'<i class="fa fa-chevron-right"></i>',
            shrinkItems: true,
            slideWidth: 1000,
            moveSlides: 1
        }
    }

    function createUpsellingCarousel(upsellingContainer, carouselConfig) {
        var upsellingCarousel = upsellingContainer.bxSlider(carouselConfig);
        destroyIfNotEnoughSlides(upsellingCarousel, carouselConfig.maxSlides);
        return upsellingCarousel;
    }

    function restartCarousel(upsellingCarousel, carouselConfig) {
        upsellingCarousel.reloadSlider(carouselConfig);
        destroyIfNotEnoughSlides(upsellingCarousel, carouselConfig.maxSlides);
        return upsellingCarousel;
    }

    function destroyIfNotEnoughSlides(upsellingCarousel, maxSlides) {
        if(upsellingCarousel.getSlideCount() <= maxSlides) {
            upsellingCarousel.destroySlider();
        }
    }

    function handleResize(uspellingCarouselsData) {
        for(var i=0; i < uspellingCarouselsData.length; i++) {
            var carouselConfig = getCarouselConfig(uspellingCarouselsData[i].carousel.prevObject);
            if(carouselConfig.maxSlides != uspellingCarouselsData[i].maxSlides) {
                uspellingCarouselsData[i].carousel = restartCarousel(uspellingCarouselsData[i].carousel, carouselConfig);
                uspellingCarouselsData[i].maxSlides = carouselConfig.maxSlides;
            }
        }
    }

    return {
        hideUpSelling: hideUpSelling,
        showUpSelling: showUpSelling,
        initCarousels: initCarousels,
        handleResize : handleResize
    }
})();

function containsDOMElement(parent, child) {
    return parent !== child && parent.contains(child);
}

var lazyLoadImageTimer;
var loadImageInterval = 1000;

function redrawCarousels(event, upsellingCarouselsData) {
    for(var i=0; i < upsellingCarouselsData.length; i++) {
       var loadedImage = $(event.target);
       var carousel = upsellingCarouselsData[i];
       var carouselContainer = upsellingCarouselsData[i].carousel[0];

       if (containsDOMElement(carouselContainer, loadedImage[0])) {
           clearTimeout(lazyLoadImageTimer);
           lazyLoadImageTimer = setTimeout(function () {
                carousel.carousel.redrawSlider(); }, loadImageInterval);
       }
    }
}

$(function () {
    var upsellingCarouselsData = UpSelling.initCarousels();
    if (upsellingCarouselsData.length) {
        $(window).on('resize', function() {
           UpSelling.handleResize(upsellingCarouselsData);
        });

        if(screen.width < 480){
            $(document).on('lazyloaded', function(event){
                redrawCarousels(event, upsellingCarouselsData);
            });
        }
    }
});
